module.exports = __webpack_public_path__ + "static/media/MV.a2b52a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MV.svg
// module id = 2217
// module chunks = 7